import { Component } from '@angular/core';

@Component({
    selector: 'app-blue-asterisk',
    templateUrl: './blue-asterisk.component.html',
    styleUrls: ['./blue-asterisk.component.scss'],
    standalone: false
})
export class BlueAsteriskComponent {
  constructor() {}
}
